import React, { useState } from "react";
import toast from "react-hot-toast";
import { Form, Input } from "antd";
import LoadableButton from "../../../components/button/LoadableButton";
import { AddUpdateInvoiceTemplateApi } from "../../../api/request/invoice";
import Delete from "../../../assets/Delete";
import Add from "../../../assets/Add";
import GlobalTooltip from "../../../components/common/GlobalTooltip";

const TemplateForm = ({ mode, setMode, selectedTemplate, getTemplateList }) => {
  const [form] = Form.useForm();
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const initialValues = {
    name: selectedTemplate?.name || "",
    charges: selectedTemplate?.charges || [
      {
        title: "",
        description: "",
        charge: "",
      },
    ],
    remark: selectedTemplate?.remark || "",
  };

  const onSubmitTemplate = async (values) => {
    try {
      setIsSubmitLoading(true);
      let data = {};

      const params = {
        ...(mode === "edit" && { invoice_temp_id: selectedTemplate?.id }),
        ...values,
      };

      if (mode === "edit") {
        const res = await AddUpdateInvoiceTemplateApi(params);
        data = res?.data;
      } else {
        const res = await AddUpdateInvoiceTemplateApi(params);
        data = res?.data;
      }

      if (data.status) {
        setIsSubmitLoading(false);
        toast.success(data.message);
        form.resetFields();
        setMode("view");
        getTemplateList();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsSubmitLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h2 className="title mb-4">
        {mode === "edit" ? "Edit Template" : "Create Template"}
      </h2>

      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onSubmitTemplate}
      >
        <Form.Item
          name="name"
          label="Template Name"
          rules={[
            {
              required: true,
              message: "Please enter the template name",
            },
          ]}
        >
          <Input placeholder="Enter template name" size="large" />
        </Form.Item>

        {/* Charges Section */}
        <Form.List name="charges">
          {(fields, { add, remove }) => (
            <div>
              {fields.map(({ key, name, ...restField }, index) => (
                <div
                  key={key}
                  className="mb-4 p-4 border rounded-lg grid grid-cols-1 md:grid-cols-3 gap-4 items-end"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "title"]}
                    label="Charge Title"
                    rules={[{ required: true, message: "Enter charge title" }]}
                    className="mb-0"
                  >
                    <Input placeholder="Enter charge title" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, "description"]}
                    label="Charge Description"
                    rules={[
                      { required: true, message: "Enter charge description" },
                    ]}
                    className="mb-0"
                  >
                    <Input placeholder="Enter charge description" />
                  </Form.Item>

                  <Form.Item
                    {...restField}
                    name={[name, "charge"]}
                    label="Charge Amount (in $)"
                    rules={[{ required: true, message: "Enter charge amount" }]}
                    className="mb-0"
                  >
                    <Input
                      type="number"
                      placeholder="Enter charge amount"
                      min={0}
                    />
                  </Form.Item>

                  {index !== 0 && (
                    <GlobalTooltip title={"Delete Charge"}>
                      <button
                        type="button"
                        className="mb-2 w-fit inline-block"
                        onClick={() => remove(name)}
                      >
                        <Delete />
                      </button>
                    </GlobalTooltip>
                  )}
                </div>
              ))}

              <button
                type="button"
                className="btn-primary !px-4 !text-sm flex items-center gap-2 mt-2"
                onClick={() => add()}
              >
                <Add />
                <span>Add Charge</span>
              </button>
            </div>
          )}
        </Form.List>

        <Form.Item
          name="remark"
          label="Remark"
          className="mt-5"
          rules={[
            {
              required: true,
              message: "Please enter the remark",
            },
          ]}
        >
          <Input.TextArea rows={4} placeholder="Enter remark" size="large" />
        </Form.Item>

        <div className="mt-5 flex gap-3">
          <LoadableButton
            type="submit"
            lable="Submit"
            isLoading={isSubmitLoading}
            loadingLable="Submitting Template..."
          />
          <button className="btn-outlined" onClick={() => setMode("view")}>
            Cancel
          </button>
        </div>
      </Form>
    </div>
  );
};

export default TemplateForm;
